export default __webpack_public_path__ + "static/media/openEye.19cab4f5.png";